export function elementFromString(str) {
    var clipboard = document.createElement('div');
    clipboard.innerHTML = str.trim();
    return clipboard.firstElementChild;
}
//# sourceMappingURL=elementFromString.js.map